export class ConsultaDocumentos{
    idTipoCredito: number;
    idCredito: number;

    constructor (idTipoCredito: number, idCredito: number ){
     this.idTipoCredito = idTipoCredito;
     this.idCredito = idCredito;
    }
}